import React from 'react';
import styled from 'styled-components';
import Collapsable from '@components/Collapsable';
import { Box, Flex, ShowInMediumDown } from '@components/layout/Grid';
import { ProgramsTitle } from '@components/texts';
import ProgramMetaCard from './ProgramMetaCard';
import { BlueSectionWrapper } from '@components/wrappers';
import ProgramExpandableInstructors from './ProgramExpandableInstructors';
import { ProgramCategory } from '@gql/generated';

export const ProgressBar = styled.div<{ flex?: number; width?: string }>`
  ${(props) =>
    props.flex
      ? `flex: ${props.flex};`
      : props.width
        ? `width: ${props.width};`
        : '407px'} height: 6px;
  border-radius: 2px;
  background-color: #d8d8d8;

  @media (max-width: ${(props) => `${props.theme.viewports.mobile}px`}) {
    ${(props) =>
      props.flex
        ? `flex: ${props.flex};`
        : props.width
          ? `width: ${props.width};`
          : '140px'};
  }
`;

export const ProgressBarValue = styled.div<{
  progressValue?: number;
  appearance: ProgramCategory;
}>`
  width: ${(props) => props.progressValue || 0}%;
  height: 6px;
  border-radius: 3px;
  background-color: ${({ theme, appearance }) =>
    appearance === ProgramCategory['Challenges']
      ? theme.colors.primary.green
      : theme.colors.primary.stone};
`;

const ProgramHeaderSection = (props) => {
  return (
    <Flex
      as={BlueSectionWrapper}
      width={1}
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap"
    >
      <Box width={[1, 1, 'auto']} mb="10px" py={25} px={20}>
        <Collapsable main={<ProgramsTitle>{props.title}</ProgramsTitle>}>
          <ProgramExpandableInstructors
            programTitle={props.title}
            instructors={props.instructors}
          />
          <Box as={ShowInMediumDown} mb="20px">
            <ProgramMetaCard
            // weekCount={props.weekCount}
            // phasesCount={props.phasesCount}
            />
          </Box>
        </Collapsable>
      </Box>
    </Flex>
  );
};

export default ProgramHeaderSection;
